<template>
    <modal-base lead-state="ringing">
        <template #subtitle>Calling your phone...</template>
    </modal-base>
</template>

<script>
    export default {
        mounted() {
            // this.$store.commit('card', 'contact');
        }
    }
</script>
